import { CheckoutState } from '../../state';
import { PaypalScriptStatus } from '../../state/paypal';
import {
    getAreAsyncExpressCheckoutEligibleCommonRulesMet,
    isPaypalAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';
import { getPaypalScriptStatus } from './pureSelectors';

export const areAsyncExpressPaypalEligibleRulesMet = (state: CheckoutState) =>
    getAreAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isPaypalAvailableAsExpressPaymentMethod(state) &&
    getPaypalScriptStatus(state) !== PaypalScriptStatus.failed;
